import { joinNavItemGroups, NavItem, NavItemSeparator } from '@billy/design-system'
import { TFunction } from 'i18next'

import { InvoiceActionType } from '../../../enums/InvoiceActionType'

export const getInvoiceActionsMenuItems = (
  activeInvoiceMenuActions: InvoiceActionType[],
  t: TFunction,
): NavItem<InvoiceActionType | NavItemSeparator>[] => {
  const menuItemGroups: NavItem<InvoiceActionType>[][] = [
    [
      {
        children: t('external_invoices.view.send_reminder'),
        iconLeft: 'bell',
        id: InvoiceActionType.SendPaymentReminder,
        value: InvoiceActionType.SendPaymentReminder,
      },
    ],
    [
      {
        children: t('external_invoices.view.mark_as_sent'),
        iconLeft: 'paperPlane',
        id: InvoiceActionType.MarkAsSent,
        value: InvoiceActionType.MarkAsSent,
      },
      {
        children: t('external_invoices.view.unmark_as_sent'),
        iconLeft: 'paperPlane',
        id: InvoiceActionType.UnmarkAsSent,
        value: InvoiceActionType.UnmarkAsSent,
      },
      {
        children: t('external_invoices.view.duplicate'),
        iconLeft: 'copy',
        id: InvoiceActionType.Duplicate,
        value: InvoiceActionType.Duplicate,
      },
    ],
    [
      {
        children: t('external_invoices.view.cancel'),
        iconLeft: 'circleX',
        id: InvoiceActionType.Cancel,
        value: InvoiceActionType.Cancel,
        variant: 'danger',
      },
      {
        children: t('invoices.side_actions.cancel_with_credit_note'),
        iconLeft: 'fileXCorner',
        id: InvoiceActionType.CreateCreditNote,
        value: InvoiceActionType.CreateCreditNote,
        variant: 'danger',
      },
    ],
  ]

  return joinNavItemGroups(
    menuItemGroups.map((group) => group.filter((item) => activeInvoiceMenuActions.includes(item.value))),
  )
}
